import React, { useEffect, useState } from 'react';
import './LoadingIndicator.scss';

export interface IOwnProps {
  visible: boolean;
}

let timer: any;

export default function LoadingIndicator({ visible }: IOwnProps) {
  const [display, setDisplay] = useState<'none' | undefined>();

  useEffect(() => {
    if (visible) {
      setDisplay(undefined);
    } else {
      clearTimeout(timer);
      timer = setTimeout(() => setDisplay('none'), 500);
    }

    return () => clearTimeout(timer);
  }, [visible])

  return <div style={{ display }} className="loading-indicator">
    <div className="status">
      <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    </div>
  </div>
}